/** Live sheet-offer flag from the vibe starters response. Null until that page has heard back. */
type Listener = () => void;

let current: boolean | null = null;
const listeners = new Set<Listener>();

export function sheetOfferEnabledSnapshot(): boolean | null {
  return current;
}

export function subscribeSheetOfferEnabled(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function publishSheetOfferEnabled(next: boolean | null): void {
  if (current === next) return;
  current = next;
  listeners.forEach(listener => listener());
}
